











import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import ShowPlayStatus from "@/components/JinroPlayer/ShowPlayStatus.vue";
import { collectionName } from "@/services/collection-name";
import Prologue from "@/components/JinroPlayer/Prologue/Prologue.vue";
import Day from "@/components/JinroPlayer/Day/Day.vue";
import Vote from "@/components/JinroPlayer/Vote/Vote.vue";
import Extravote from "@/components/JinroPlayer/ExtraVote/ExtraVote.vue";
import Execution from "@/components/JinroPlayer/Execution/Execution.vue";
import Night from "@/components/JinroPlayer/Night/Night.vue";
import Ending from "@/components/JinroPlayer/Ending/Ending.vue";
import Afternight from "@/components/JinroPlayer/AfterNight/AfterNight.vue";
import { JinroGamePlayinfoDocument } from "@/services/datatypes";
import JinroGameNotification from "@/components/JinroPlayer/JinroGameNotification.vue";

@Component({
  components: {
    ShowPlayStatus,
    JinroGameNotification,
    Prologue,
    Day,
    Vote,
    Extravote,
    Execution,
    Night,
    Ending,
    Afternight // AfterNighとするとerror,
  }
})
export default class JinroGamePlayInfo extends Vue {
  @Prop() readonly jinroGameId!: string;
  msLeft = 30;
  detacher?: firebase.Unsubscribe;
  jinroGamePlayinfo: JinroGamePlayinfoDocument | null = null;

  get dayN(): number {
    if (this.jinroGamePlayinfo) {
      return this.jinroGamePlayinfo.dayN ? this.jinroGamePlayinfo.dayN : 0;
    }
    return 0;
  }

  get jinroPlayinfoId(): string {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame.currentJinroPlayinfoId;
    }
    return "";
  }

  get leftTime(): number {
    return this.msLeft;
  }

  get currentStatus(): string {
    if (this.jinroGamePlayinfo) {
      // 大文字小文字関係なし
      return this.jinroGamePlayinfo.playStatus;
    }
    return "";
  }

  get playStatus(): string {
    if (this.jinroGamePlayinfo) {
      return this.jinroGamePlayinfo.playStatus;
    }
    return "";
  }

  @Watch("jinroPlayinfoId")
  onChange() {
    this.onSnapJinroPlayInfo();
  }

  async onSnapJinroPlayInfo() {
    if (this.jinroGameId && this.jinroPlayinfoId) {
      this.detacher = this.refJinroGamePlayInfo.onSnapshot(snapshot => {
        this.jinroGamePlayinfo = snapshot.data() as JinroGamePlayinfoDocument;
        this.$store.commit("setJinroGamePlayinfo", this.jinroGamePlayinfo);
      });
    }
  }

  get refJinroGamePlayInfo(): firebase.firestore.DocumentReference {
    return db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinroplayinfo)
      .doc(this.jinroPlayinfoId);
  }
  async created() {
    this.onSnapJinroPlayInfo();
  }

  destroyed() {
    this.detacher && this.detacher();
  }
}
